<template>
  <div class="container">
    <h1>Start Your Free API Trial</h1>

    <div class="highlight-box">
      You’ll receive <strong>500 free API credits</strong> to explore all available endpoints at your own pace.
    </div>

    <p class="info-text">
      To get started, simply email us at:
      <br />
      <a class="email-link" href="mailto:support@vedicastrochart.com">support@vedicastrochart.com</a>
    </p>

    <p class="info-text">
      Please email from the address where you’d like to receive your trial API key.
      You may also include a short note about how you plan to use the API — this helps us support your project better.
    </p>

    <p class="info-text">
      Our team will get back to you within 24 hours. We look forward to helping you integrate Vedic astrology into your app, website, or research tool!
    </p>

    <button class="cta-button" @click="$router.push('/')">Home</button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
</script>

<style scoped>
.container {
  max-width: 720px;
  margin: 0 auto;
  padding: 30px 20px;
  background-color: #EDF6F9;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  font-family: 'Segoe UI', sans-serif;
}

h1 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #222;
  text-align: center;
}

.highlight-box {
  background-color: #FBFBFF;
  border-left: 5px solid #087F8C;
  padding: 15px 20px;
  margin-bottom: 25px;
  font-size: 15px;
  line-height: 1.6;
}

.email-link {
  display: inline-block;
  font-weight: bold;
  color: #087F8C;
  text-decoration: none;
  word-break: break-word;
}

.email-link:hover {
  text-decoration: underline;
}

.info-text {
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 20px;
}

.cta-button {
  display: block;
  margin: 30px auto 0;
  background-color: #087F8C;
  color: white;
  font-weight: bold;
  border: none;
  padding: 12px 28px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.cta-button:hover {
  background-color: #218838;
}

@media (max-width: 600px) {
  h1 {
    font-size: 22px;
  }
}
</style>
